var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mastercard-color_large"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "card_bg",
    width: 32,
    height: 21.3333,
    rx: 4,
    fill: "#F2F0EC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mastercard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.10156,
    y: 2.13333,
    width: 25.8067,
    height: 17.0667,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 12.6016,
    y: 5.10667,
    width: 6.80667,
    height: 11.12,
    fill: "#F26122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M13.3338 10.6667C13.3226 8.50235 14.3056 6.45269 16.0005 5.10666C13.1007 2.82619 8.93512 3.15734 6.43201 5.86733C3.92891 8.57732 3.92891 12.756 6.43201 15.466C8.93512 18.176 13.1007 18.5071 16.0005 16.2267C14.3056 14.8806 13.3226 12.831 13.3338 10.6667Z",
    fill: "#EA1D25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7583 14.82V15.0467H26.7183V14.82H26.625V14.7733H26.8583V14.82H26.7583ZM27.212 14.7733V15.0467H27.1653V14.84L27.092 15.02H27.0386L26.9586 14.84V15.0467H26.912V14.7733H26.9786L27.0653 14.9667L27.1453 14.7733H27.212Z",
    fill: "#F69E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M27.44 10.6667C27.4383 13.3729 25.8926 15.8409 23.4586 17.0239C21.0246 18.2068 18.129 17.8973 16 16.2267C19.0667 13.812 19.5978 9.36953 17.1867 6.3C16.841 5.85551 16.4425 5.45478 16 5.10666C18.129 3.43599 21.0246 3.12649 23.4586 4.30944C25.8926 5.4924 27.4383 7.96043 27.44 10.6667Z",
    fill: "#F69E1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.acbf6640c9973066e81269e9513d298f.svg";
export { ForwardRef as ReactComponent };